import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 22\" id=\"share\"><defs><path id=\"share_a\" d=\"M0 0h22v14H0z\" /></defs><g transform=\"translate(0 4)\" fill=\"none\" fill-rule=\"evenodd\"><mask id=\"share_b\" fill=\"#fff\"><use xlink:href=\"#share_a\" /></mask><path d=\"M22 7l-8 6h-2v-3c-7 0-10 4-11 4l-1-1s1-9 12-9V1l1-1h1l8 6v1\" fill=\"currentColor\" mask=\"url(#share_b)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol